import { ButtonPseudo } from '@ui/src';
import cn from './profile.module.css';

const ProfileEntryAndSecurity = ({
  setDevicesPanelVisible,
}: {
  setDevicesPanelVisible: (data: boolean) => void;
}) => (
  <>
    <div className={cn.employeeProfileTitle}>Entry and security</div>
    <div className={cn.employeeProfilePermissionWrapper}>
      <div className={cn.employeeProfilePermissionPage}>
        <div className={cn.employeeProfilePermissionPageTitle}>Devices</div>
        <div className={cn.employeeProfilePermissionPageActions}>
          <ButtonPseudo
            text="View"
            onClick={() => setDevicesPanelVisible(true)}
          />
        </div>
      </div>
    </div>
  </>
);

export default ProfileEntryAndSecurity;
